export default function linkResolver(doc) {
  return `/${doc.uid}`;
}
